import { render, staticRenderFns } from "./DashboardWidgetInfo.vue?vue&type=template&id=10194026"
import script from "./DashboardWidgetInfo.vue?vue&type=script&lang=ts"
export * from "./DashboardWidgetInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports